export default __webpack_public_path__ + "static/rec-2010-iii-8bea59777d99494abdb147002182fc60.png";